import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 244.000000 295.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,295.000000) scale(0.100000,-0.100000)"
        >
          <path
            d="M1141 2670 c-190 -26 -335 -79 -480 -173 -94 -62 -239 -207 -309
-310 -311 -461 -298 -1079 33 -1518 168 -224 391 -367 658 -425 108 -24 308
-21 407 6 219 59 361 140 516 294 213 213 338 489 363 806 23 286 -52 580
-214 828 -91 142 -278 309 -431 385 -167 84 -390 128 -543 107z m-36 -292
c132 -315 241 -577 291 -698 88 -212 128 -269 202 -285 18 -4 32 -13 32 -21 0
-12 -36 -14 -215 -14 -184 0 -215 2 -215 15 0 9 14 17 39 21 30 5 43 13 56 38
15 29 15 34 -3 86 -34 97 -84 210 -92 210 -5 0 -16 -10 -24 -22 -13 -19 -16
-58 -16 -230 l0 -208 255 0 255 0 0 194 c0 115 -4 206 -11 225 -14 38 -54 61
-109 61 -33 0 -40 3 -40 20 0 20 5 20 238 18 203 -3 237 -5 237 -18 0 -15 -5
-17 -63 -19 -23 -1 -43 -11 -63 -30 l-29 -29 0 -457 c0 -308 4 -463 11 -477
13 -25 68 -48 114 -48 24 0 35 -4 35 -15 0 -13 -33 -15 -240 -15 -197 0 -240
2 -240 14 0 9 17 15 51 18 38 4 58 12 77 32 l27 26 3 220 3 220 -255 0 -256 0
0 -220 c0 -208 1 -221 20 -240 27 -27 62 -40 106 -40 24 0 34 -5 34 -15 0 -13
-33 -15 -240 -15 -207 0 -240 2 -240 15 0 11 11 15 39 15 46 0 102 35 112 70
4 14 7 218 8 453 1 355 -2 434 -14 463 l-14 35 -96 -3 -96 -3 -50 -117 c-27
-65 -49 -129 -49 -144 0 -29 34 -63 65 -64 37 -1 65 -12 65 -26 0 -11 -33 -14
-175 -14 -141 0 -175 3 -175 14 0 7 19 21 43 30 58 22 101 84 158 228 11 29
27 67 34 83 31 67 313 732 319 753 4 12 15 22 26 22 14 0 29 -27 65 -112z"
          />
          <path
            d="M902 2008 l-92 -213 182 -3 c99 -1 183 -1 185 1 2 3 -27 78 -65 168
-38 90 -78 185 -88 211 -10 27 -22 48 -25 48 -3 0 -47 -96 -97 -212z"
          />
        </g>
      </svg>
    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
